module.exports = __webpack_public_path__ + "static/media/C019.54bde743.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C019.jpg
// module id = 302
// module chunks = 0